import React from 'react'

const Manual_beneficio_2x1 = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear un beneficio 2x1
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_un_beneficio_2x1__c7npu0YRRnmkUVP61wGEyA?as=scrollable"
          className="scribe-iframe-general-137"
          width="100%"
          height="10000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_beneficio_2x1
